import React from 'react';
import { getLabel } from 'utils/getLabel';
import { map, isEmpty } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { Icon } from 'modules/icon-bank';

// Success View
export const authFlowVerificationPreVerifiedMembersSuccess = ( props ) => {

    return (
        !isEmpty( props.members ) ? (
            <div className='ui-auth-flow-verification-pre-verified-members'>

                {/* title */}
                <div className='ui-auth-flow-verification-pre-verified-members__title'>
                    { getLabel( props.titles.title ) }

                </div>

                { /* members */ }
                <div className='ui-auth-flow-verification-pre-verified-members__members'>
                    { !isEmpty( props.members ) ? (
                        map( props.members, ( member ) => {

                            // get icon color
                            const iconColor = THEME.themeColorPrimary2;

                            return (
                                <div
                                    key={ member.id }
                                    className='ui-auth-flow-verification-pre-verified-members__members__item'
                                    onClick={ () => props.handleOnClickAction( { id: member.id } ) }
                                >
                                    {/* icon */}
                                    <Icon
                                        className='ui-auth-flow-verification-pre-verified-members__members__item__icon'
                                        name={ member.gender }
                                        fill={ iconColor }
                                        stroke={ iconColor }
                                    />

                                    {/* name */}
                                    <p className='ui-auth-flow-verification-pre-verified-members__members__item__name'>
                                        { member.name }
                                    </p>

                                    {/* relationship */}
                                    <p className='ui-auth-flow-verification-pre-verified-members__members__item__relationship'>
                                        { member.displayId }
                                    </p>
                                </div>
                            );
                        } )
                    ) : (
                        <div className='ui-auth-flow-verification-pre-verified-members__members__title'>
                            { getLabel( props.titles.noData ) }
                        </div>
                    )}
                </div>
            </div>
        ) : null
    );
};

// set display name
authFlowVerificationPreVerifiedMembersSuccess.displayName = 'authFlowVerificationPreVerifiedMembersSuccess';

// set default props
authFlowVerificationPreVerifiedMembersSuccess.defaultProps = {
    title: null,
    members: [],
    options: {},
};

// prop types
authFlowVerificationPreVerifiedMembersSuccess.propTypes = {};

/*******************************/

// preloader view
export const authFlowVerificationPreVerifiedMembersPreloader = () => {
    return (
        <div className='ui-auth-flow-verification-pre-verified-members-preloader'>
            <div className='ui-auth-flow-verification-pre-verified-members-preloader__family-unit'>
                <div className='ui-auth-flow-verification-pre-verified-members-preloader__family-unit__member'>
                    <div className='ui-auth-flow-verification-pre-verified-members-preloader__family-unit__member__icon__preloader'></div>
                    <div className='ui-auth-flow-verification-pre-verified-members-preloader__family-unit__member__preloader'></div>
                </div>
                <div className='ui-auth-flow-verification-pre-verified-members-preloader__family-unit__member'>
                    <div className='ui-auth-flow-verification-pre-verified-members-preloader__family-unit__member__icon__preloader'></div>
                    <div className='ui-auth-flow-verification-pre-verified-members-preloader__family-unit__member__preloader'></div>
                </div>
                <div className='ui-auth-flow-verification-pre-verified-members-preloader__family-unit__member'>
                    <div className='ui-auth-flow-verification-pre-verified-members-preloader__family-unit__member__icon__preloader'></div>
                    <div className='ui-auth-flow-verification-pre-verified-members-preloader__family-unit__member__preloader'></div>
                </div>
            </div>
        </div>
    );
};

// set display name
authFlowVerificationPreVerifiedMembersPreloader.displayName = 'authFlowVerificationPreVerifiedMembersPreloader';

// set default props
authFlowVerificationPreVerifiedMembersPreloader.defaultProps = {};

// prop types
authFlowVerificationPreVerifiedMembersPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { authFlowVerificationPreVerifiedMembers as AuthFlowVerificationPreVerifiedMembers } from 'ui/views/widgets/authFlowVerificationPreVerifiedMembers';
 *
 * // render
 * <AuthFlowVerificationPreVerifiedMembers propName='propValue'/>
 */
export const authFlowVerificationPreVerifiedMembers = withNetworkState( authFlowVerificationPreVerifiedMembersPreloader, authFlowVerificationPreVerifiedMembersSuccess );

